import React, { useEffect } from 'react';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';

const TermsOfService = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />

      <main className="flex-grow bg-white pt-20 md:pt-24">
        <div className="container mx-auto px-6 md:px-4 py-8 md:py-12">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-3xl sm:text-4xl font-medium text-gray-800 mb-4 font-trends">
              Terms of Service
            </h1>
            <h2 className="text-xl sm:text-2xl text-gray-800 mb-6 font-trends">
              Chase the Chickens
            </h2>
            <p className="text-gray-600 mb-8">Effective Date: January 12, 2025</p>

            <p className="text-lg md:text-xl text-gray-800 mb-8">
              Welcome to Chase the Chickens! These Terms of Service govern your access to and use of our website and app. By using our services, you agree to these terms.
            </p>

            <div className="space-y-8 md:space-y-12">
              {/* Eligibility */}
              <section>
                <h2 className="text-2xl font-medium text-gray-800 mb-4">1. Eligibility</h2>
                <p className="text-gray-600">
                  Users must be at least 18 years old to participate in games involving alcohol. Minors are not permitted to use the app.
                </p>
              </section>

              {/* Accounts */}
              <section>
                <h2 className="text-2xl font-medium text-gray-800 mb-4">2. Accounts</h2>
                <p className="text-gray-600">
                  You are responsible for maintaining the confidentiality of your login details and ensuring their use complies with these terms. Accounts may be suspended or terminated if fraudulent or abusive activity is detected.
                </p>
              </section>

              {/* Gameplay Rules */}
              <section>
                <h2 className="text-2xl font-medium text-gray-800 mb-4">3. Gameplay Rules</h2>
                <p className="text-gray-600">
                  Adherence to local laws regarding alcohol consumption is required. Rock Software is not responsible for misuse or violations. Players must use the app honestly and avoid tampering with tracking or verification features.
                </p>
              </section>

              {/* Payments and Refunds */}
              <section>
                <h2 className="text-2xl font-medium text-gray-800 mb-4">4. Payments and Refunds</h2>
                <p className="text-gray-600">
                  All payments made to the collective pot or for in-app purchases are final. Refunds are only provided in cases of technical errors caused by us.
                </p>
              </section>

              {/* Prohibited Activities */}
              <section>
                <h2 className="text-2xl font-medium text-gray-800 mb-4">5. Prohibited Activities</h2>
                <p className="text-gray-600 mb-4">You agree not to:</p>
                <ul className="space-y-3 text-gray-600">
                  <li className="flex space-x-3">
                    <span className="text-[#E57373] mt-1.5">•</span>
                    <span>Use the app for illegal activities</span>
                  </li>
                  <li className="flex space-x-3">
                    <span className="text-[#E57373] mt-1.5">•</span>
                    <span>Attempt to hack or disrupt the app</span>
                  </li>
                  <li className="flex space-x-3">
                    <span className="text-[#E57373] mt-1.5">•</span>
                    <span>Share offensive or harmful content</span>
                  </li>
                </ul>
              </section>

              {/* Limitation of Liability */}
              <section>
                <h2 className="text-2xl font-medium text-gray-800 mb-4">6. Limitation of Liability</h2>
                <p className="text-gray-600 mb-4">Rock Software is not liable for:</p>
                <ul className="space-y-3 text-gray-600">
                  <li className="flex space-x-3">
                    <span className="text-[#E57373] mt-1.5">•</span>
                    <span>Damages resulting from misuse of the app</span>
                  </li>
                  <li className="flex space-x-3">
                    <span className="text-[#E57373] mt-1.5">•</span>
                    <span>Accidents or injuries during gameplay</span>
                  </li>
                  <li className="flex space-x-3">
                    <span className="text-[#E57373] mt-1.5">•</span>
                    <span>Technical interruptions or data loss</span>
                  </li>
                </ul>
              </section>

              {/* Additional Sections */}
              <section>
                <h2 className="text-2xl font-medium text-gray-800 mb-4">7. Changes to These Terms</h2>
                <p className="text-gray-600">
                  We reserve the right to update these terms. Continued use of the app after updates indicates acceptance.
                </p>
              </section>

              {/* Contact Section */}
              <section>
                <h2 className="text-2xl font-medium text-gray-800 mb-4">Contact Us</h2>
                <p className="text-gray-600 mb-4">If you have questions about these Terms of Service, please contact us at:</p>
                <div className="space-y-2 text-gray-600">
                  <p><strong>Email:</strong> support@chasethechickens.co.uk</p>
                  <p><strong>Mail:</strong> Rock Software, 123 Game Street, London, UK</p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default TermsOfService;